<script setup>
import {stripHtml} from '~/utils/stripHtml.js'

const props = defineProps({
  src: {
    type: String,
    required: true
  },
  mobileSrc: {
    type: String,
    default: ''
  },
  alt: {
    type: String,
    default: ''
  },
  preload: {
    type: Boolean,
    default: false
  },
  fetchpriority: {
    type: String,
    default: ''
  },
  loading: {
    type: String,
    default: ''
  },
  static: {
    type: Boolean,
    default: false
  }
})

const src = computed(() => props.src)
const mobileSrc = computed(() => props.mobileSrc)
const plainAlt = computed(() => stripHtml(props.alt))

if (props.preload) {
  const link = (href, media) => {
    const tag = {rel: 'preload', href, as: 'image'}

    if (media) {
      tag.media = media
    }

    if (props.fetchpriority) {
      tag.fetchpriority = props.fetchpriority
    }

    return tag
  }

  const links = props.mobileSrc
      ? [
        link(src, '(min-width: 1024px)'),
        link(mobileSrc, '(max-width: 1023px)'),
      ]
      : [
        link(src),
      ]

  useHead({link: links})
}
</script>

<template>
  <picture :class="{static:static}">
    <source media="(min-width: 1024px)" :srcset="src">
    <source media="(max-width: 1023px)" v-if="mobileSrc" :srcset="mobileSrc">
    <img
        :loading="loading || undefined"
        :fetchpriority="fetchpriority || undefined"
        :src="src"
        :alt="plainAlt"
    />
  </picture>
</template>

<style scoped>
picture {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;

  &.static {
    position: static;
  }
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
